@if (appState().session; as userSession) {
  <div class="h-full select-none flex-row-center cursor-pointer" [matMenuTriggerFor]="menu">
    <div>
      {{ userSession.user.name }}
    </div>

    <fa-icon class="ms-2" [icon]="faChevronDown" />
  </div>

  <mat-menu #menu="matMenu">
    <button mat-menu-item [routerLink]="AppUrls.Company._.Join.absoluteUrl">
      <fa-icon [icon]="faEnvelopeOpenText" class="me-2" />
      <span i18n>Invitations</span>
    </button>
    <a mat-menu-item target="_blank" [href]="environment.links.helpSiteUrl">
      <fa-icon [icon]="faQuestion" class="me-2" />
      <span i18n>Help</span>
    </a>
    <button mat-menu-item (click)="logoutAsync()">
      <fa-icon [icon]="faRightFromBracket" class="me-2" />
      <span i18n>Log out</span>
    </button>
  </mat-menu>
} @else {
  <div class="flex-row-center">
    <button mat-button [routerLink]="RouteLocations.Auth._.Login.absoluteUrl">Sign In</button>

    <button
      mat-stroked-button
      [routerLink]="RouteLocations.Auth._.Registration.absoluteUrl"
      class="ms-2"
      i18n
    >
      Sign Up
    </button>
  </div>
}
